import { createAsyncThunk } from '@reduxjs/toolkit';
import AuthService from '../../../api/services/AuthService';

export const register = createAsyncThunk('auth/register', async ({ affiliateId, influencerId }) => {
  return await AuthService.register(affiliateId, influencerId);
});

export const getUserInfo = createAsyncThunk('auth/getUserInfo', async ({ affiliateId }) => {
  return await AuthService.getUserInfo(affiliateId);
});
